const cryptoWalletsRegex = {
  NEO: { NEO: /^N[0-9A-Za-z]{33}$/ },
  XEM: { XEM: /^(NA|NB|NC|ND)[a-zA-z0-9]{38}$/ }
};

const validateCryptoWallet = (asset, wallet, network) => {
  let WAValidator = require("multicoin-address-validator");

  let WAValidator2 = require("@swyftx/api-crypto-address-validator");

  if (cryptoWalletsRegex?.[asset]?.[network]?.test(wallet)) {
    return true;
  }

  if (asset === "USDT" && network === "ERC20") {
    asset = "ETH";
  }

  if (asset === "USDT" && network === "OMNI") {
    asset = "BTC";
  }

  if (asset === "USDT" && network === "TRC20") {
    asset = "TRX";
  }

  if (asset === "USDC" && network === "TRC20") {
    asset = "TRX";
  }

  if (asset === "USDC" && network === "ERC20") {
    asset = "ETH";
  }

  if (asset === "GALA" && network === "GALA") {
    asset = "ETH";
  }

  if (asset === "AVAX" && network === "CCHAIN") {
    asset = "ETH";
  }

  if (asset === "SAND" && network === "SAND") {
    asset = "ETH";
  }

  if (asset === "AXS" && network === "AXS") {
    asset = "ETH";
  }

  try {
    return WAValidator.validate(wallet, asset);
  } catch (e) {
    try {
      return WAValidator2.validate(wallet, asset);
    } catch (e) {
      return true;
    }
  }

};

const validateCardNumber = (cardNo) => {
  let s = 0;
  let doubleDigit = false;
  for (let i = cardNo.length - 1; i >= 0; i--) {
    let digit = +cardNo[i];
    if (doubleDigit) {
      digit *= 2;
      if (digit > 9)
        digit -= 9;
    }
    s += digit;
    doubleDigit = !doubleDigit;
  }
  return s % 10 === 0;

};

export {
  validateCryptoWallet,
  validateCardNumber
};
